import { orders } from './orders';
import { campaign } from './campaign';
import { cart } from './cart';
import { customer } from './customer';
import { market } from './market';
import { review } from './review';

export const api = { campaign, cart, orders, customer, market, review };

/* 타입의 경우 하단에 export 해주세요 */
export * from './campaign/types';
export * from './orders/types';
export * from './customer/types';
export * from './market/types';
export * from './cart/types';
export * from './review/types';
